import { render } from "./TwoChairsBlackGold_2026.vue?vue&type=template&id=6e5eb3a0"
const script = {}

import exportComponent from "/Users/taesungkim/Git/parnas-app-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__